export const getBSWholeWheatEnglishMuffinsPackage = newProduct => {
  const newBSWholeWheatEnglishMuffinsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatEnglishMuffinsPackage
}

export const updateBSWholeWheatEnglishMuffinsPackage = newProduct => {
  const newBSWholeWheatEnglishMuffinsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatEnglishMuffinsPackage
}
